import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién empiezo con Biodescodificación?',
  a: 'Especialmente si recién empezás. El Kit Maestro te da la estructura desde la primera sesión. No tenés que improvisar ni esperar años. El Tomo I es tu marco legal, el Tomo II son tus recursos de exploración, el Tomo III son tus prácticas simbólicas de integración listas para proponer. Muchas terapeutas lo usan desde el día 1.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de la compra recibirás un email con el link de descarga. Todos los archivos están en PDF, listos para descargar, imprimir o consultar en tu tablet durante las sesiones.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No. Muchas terapeutas lo tienen en tablet durante la sesión. Otros imprimen solo los tomos principales. Otros imprimen solo los bonus. Vos elegís. Los archivos están optimizados para ambas opciones.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía completa. Si en esos 7 días no estás satisfecho, devolvemos tu dinero. Sin preguntas. Sin condiciones.'
}, {
  q: '¿Puedo compartirlo con otras terapeutas?',
  a: 'El material es para uso personal. Compartirlo violaría nuestros términos. Si tus colegas quieren acceso, cada una compra su propio kit. Así apoyás el trabajo detrás de esto.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-82" data-mp="rzue7r55qlv3">
      <div className="mb-10 text-center" data-id="element-83" data-mp="s0w1qv3d10tp">
        <h2 className="flex justify-center font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-84" data-mp="wxw52y8trph4">
          <span className="mr-3" data-id="element-85" data-mp="ixuvmuehv9q1">❓</span>LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-4" data-id="element-86" data-mp="mzq7gsu1x5i2">
        {faqs.map((faq, index) => <div key={faq.q} className="paper-panel overflow-hidden rounded-2xl border-l-4 border-l-brand-blueMid" data-id="element-87" data-mp="n22jkpd4oln7" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-parchment focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber" data-id="element-88" data-mp="2kvwxwewi1l3c">
              <span className="pr-8 text-sm font-semibold text-brand-blue md:text-base" data-id="element-89" data-mp="33mo6vfckr9h7">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-90" data-mp="2ymsb23e16ocq" />
            </button>
            <AnimatePresence initial={false} data-id="element-91" data-mp="1n97ovl3dq87z">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-92" data-mp="1j6bdaec9bcdj">
                  <p className="border-t border-brand-blue/10 bg-white px-6 py-4 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-93" data-mp="7ooy0nmfy6b0">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}